import { moduleState } from 'cerebral'
import apiClient from '../../lib/util/api-client'
import { crudActions } from '../factories'

export const { find, setList, clearList, get, save, remove } = crudActions({ name: 'printOrders' })

const printOrdersPricingService = apiClient.service('print-orders/pricing')
const shippingMethodsService = apiClient.service('print-orders/shipping-methods')

export const getEstimatePricing = async ({ props: { orderItems, shippingLevel } = {} }) => {
  return printOrdersPricingService.create({ orderItems, shippingLevel })
}

export const getShippingMethods = async ({ props: { items = [], address = {} } = {} }) => {
  const shippingMethods = await shippingMethodsService.create({ items, address })
  return { shippingMethods }
}

export const getDraftPrintOrders = async ({ printOrdersService: service, store }) => {
  const response = await service.find({ filter: 'draft' })
  store.set(moduleState`draftPrintOrders`, response.total > 0 ? response.data : [])
}
